/**
 * 文字列(YYYY/MM/DD, YYYY-MM-DD (HH:mm:SSもあれば)) -> 日付変換
 * @param {String} dateStr 文字列
 */

function convertDate(dateStr) {
  let res = null
  if (typeof dateStr == 'string') {
    let str = dateStr.replace(/-/g, '/')
    let match = str.match(/^(\d+)\/(\d+)\/(\d+)$/)
    if (match) {
      const y = parseInt(match[1])
      const m = parseInt(match[2]) - 1
      const d = parseInt(match[3])
      res = new Date(y, m, d, 0, 0, 0)
      return res
    }
    match = str.match(/^(\d+)\/(\d+)\/(\d+) ([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/)
    if (match) {
      const y = parseInt(match[1])
      const m = parseInt(match[2]) - 1
      const d = parseInt(match[3])
      const hh = parseInt(match[4])
      const mm = parseInt(match[5])
      const ss = parseInt(match[6])
      res = new Date(y, m, d, hh, mm, ss)
      return res
    }
  }
  return res
}

/**
 * 文字列() -> HRM用性別変換
 * @param {String} str 文字列
 * 0: 設定なし, 1: 男性, 2: 女性, 3:選択しない
 */

function convertGender(str) {
  if (typeof str == 'string') {
    if (str.indexOf('男') >= 0) {
      return 1
    } else if (str.indexOf('女') >= 0) {
      return 2
    } else if (str.indexOf('選択しない') >= 0) {
      return 3
    }
  }
  return 0
}

export { convertDate, convertGender }



// WEBPACK FOOTER //
// ./src/functions/common/convertFunc.js